import CustomButton from "Components/Custom/CustomButton";
import { useAppSelector } from "Components/Hooks/hooks";
import React from "react";
import { tourElementsIds } from "tour/tourElementsIds";

interface DashboardHeaderProps {
  onNewClientClick: () => void;
  onNewInVoiceClick: () => void;
  onNewQuotesClick: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onNewClientClick,
  onNewInVoiceClick,
  onNewQuotesClick,
}) => {
  const user = useAppSelector((state) => state?.auth?.user);

  function formatToday(): string {
    const date = new Date();
    const day = date.getDate();
    const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
    const month = date.toLocaleDateString("en-GB", { month: "short" });

    const getSuffix = (day: number): string => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${weekday}, ${day}${getSuffix(day)} ${month}`;
  }

  const actions = [
    {
      label: "New Quote",
      onClick: onNewQuotesClick,
      leftIcon: <i className="ri-add-fill me-1 align-bottom"></i>,
    },
    {
      label: "New Invoice",
      onClick: onNewInVoiceClick,
      leftIcon: <i className="ri-add-fill me-1 align-bottom"></i>,
    },
    {
      label: "Add Client",
      onClick: onNewClientClick,
      leftIcon: <i className="ri-add-fill me-1 align-bottom"></i>,
    },
  ];

  return (
    <div className="dashboard-header">
      {/* LEFT */}
      <div className="dashboard-header__left">
        <p className="text-grey89 fw-medium fs-14 font-primary m-0">
          {formatToday()}
        </p>

        <p className="dashboard-header__welcome text-black2D fw-bold fs-24 font-primary m-0">
          Welcome back, {user?.name}! 👋
        </p>
      </div>

      {/* RIGHT */}
      <div
        className="dashboard-header__actions"
        id={tourElementsIds.dashboardTour2}
      >
        {actions.map((btn, index) => (
          <CustomButton
            key={index}
            text={btn.label}
            className="bg-primary br-7"
            textClassName="text-white"
            onClick={btn.onClick}
            leftIcon={btn.leftIcon}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(DashboardHeader);
